



































































































import { getCouponCount } from '@/apps/index/models/api'
import { removeFromFavoriteList, addToFavoriteList } from '@/apps/personal/models/api'
import { Component, Vue, Prop, Provide, Emit } from 'vue-property-decorator'
import { AButton } from '@/components'
import { loadFromLocal } from '@/utils/local'
import DownloadTip from '@/components/vip/DownloadTip.vue'
import { PAGES } from './models/api'
import axios from 'axios'
import { SUBJECT_MAP } from '@/apps/assessment/model/common'

@Component({
  components: { AButton, DownloadTip }
})
export default class PaperItem extends Vue {
  public dataConfig: any = {}
  public avatar = {
    shape: 'square',
    size: 'large'
  }
  public tipShow = false
  public favorite = true
  public hasAudio = false

  @Prop() public loading!: boolean
  @Prop() public data!: any
  @Prop() public name!: any
  @Prop() public type!: string
  @Prop({ default: '收藏' }) public removeFavoriteTxt!: string
  @Prop({
    default() {
      return true
    }
  })
  public canIcollect!: boolean
  @Prop({
    default() {
      return ''
    }
  })
  public from!: string
  /**
   * name
   */
  public realDownload(val: any) {
    this.tipShow = false
    let temp = Object.assign({}, val, this.dataConfig)
    this.clickDownload(temp)
  }
  public cancelDownloadShow(val: any) {
    this.tipShow = false
  }
  public async clickDownloadTip(data: any) {
    // 详情的is_high_quality 字段就是列表中的 is_excellent字段
    if (data.is_high_quality) {
      data.is_excellent = true
    }
    this.dataConfig = data
    if (this.dataConfig.is_excellent) {
      this.checkAudio()
    } else {
      this.realDownload({})
    }
  }
  @Emit()
  public clickDownload(data: any) {
    return data
  }
  public get subjectId() {
    return this.$store.state.subject.value || this.$route.query.subject_id || ''
  }
  public get getFilters() {
    return this.$store.state.filters
  }
  public get date() {
    return this.$route.query.date || ''
  }
  public get userName() {
    return this.$store.state.user_info && this.$store.state.user_info.nickname
  }
  private get _id() {
    return this.data.id || this.data.paper_id
  }
  public get getAPI() {
    let query = this.$route.query
    let page = 'paper'
    if (query && query.ceping === '1') {
      page = 'assessment'
    } else if (query && query.assemble === '1') {
      page = 'assemble'
    } else {
      page = 'paper'
    }
    return PAGES[page]
  }
  public async checkAudio() {
    try {
      const { data }: any = await axios.post(`/api/${this.getAPI.url}`, {
        [this.getAPI.param]: this._id
      })
      if (data.success) {
        this.hasAudio = data.data.has_audio
        // console.log(this.hasAudio)
      }
    } catch (e) {
      console.log(e)
    } finally {
      this.tipShow = true
    }
  }
  public findDetail() {
    if (this.type === 'large') {
      return
    } else {
      window['sensors'].track('TIKU_preview_content', {
        proSource: this.from,
        content: '试卷',
        paper_subject: this.$store.state.subject.label,
        is_not: this.data.is_excellent || this.data.is_high_quality ? '是' : '否'
      })
      if (!this.userName) {
        this.$store.commit('SET_LOGINMODAL', true)
        return
      }
      this.$store.commit('SET_SUBJECT', {
        label: this.data.subject_text,
        value: this.data.subject_id,
        nick: SUBJECT_MAP[this.data.subject_id]
      })
      window.open(
        '/detail' +
          `?_id=${this.data.paper_id}&subject_id=${this.subjectId}&assemble=${
            this.data.is_assemble ? 1 : 0
          }`
      )
    }
  }
  public imageUrl(data) {
    if (data) {
      return require(`@/assets/svg/${data}`)
    } else {
      return require(`@/assets/svg/file.svg`)
    }
  }
  public getDate(val) {
    if (val) {
      return val
    } else {
      return this.date
    }
  }
  // 是否为精排卷
  public judgeVersion(val) {
    if (val)
      return '<span style="color: #386BFF; font-size: 12px;vertical-align: text-top;">【精排】</span>'
    return ''
  }
  // 是否为名校试卷
  public judgeFamousPaper(val: boolean) {
    if (val) {
      return '<span style="color: #386BFF; font-size: 12px; margin-right: 0; vertical-align: text-top;">【名校试卷】</span>'
    }
    return ''
  }
  // 我的收藏相关操作
  public async addToFavorite() {
    window['sensors'].track('TIKU_otherFunction_clk', {
      moduleName: this.from,
      functionName: '收藏'
    })

    try {
      let data: any = await addToFavoriteList({
        doc_id: (this.data && this.data.paper_id) || this.data.id,
        category: 1,
        subject_id: this.subjectId
      })
      if (data.success) {
        this.$emit('handleFavoritelist', 'add')
        this.data.is_collected = true
        this.$message.success('收藏成功')
      }
    } catch (e) {
      console.log(e)
    }
  }
  public async removeFromFavorite() {
    window['sensors'].track('TIKU_otherFunction_clk', {
      moduleName: this.from,
      functionName: '取消收藏'
    })

    try {
      let data: any = await removeFromFavoriteList({
        doc_id: (this.data && this.data.paper_id) || this.data.id,
        category: 1
      })
      if (data.success) {
        this.$emit('handleFavoritelist', 'remove')
        this.data.is_collected = false
        this.$message.success('已移除收藏')
      }
    } catch (e) {
      console.log(e)
    }
  }
}
